// const apiRoot = 'http://localhost:3600'
const apiRoot = 'https://knbm2ppj38.execute-api.eu-west-1.amazonaws.com/dev'

export const apiEndpoints = {
	authUser: `${apiRoot}/auth`,
	getUser: `${apiRoot}/getuser`,
	modifyUser: `${apiRoot}/modifyuser`,
	insertNewInvoice: `${apiRoot}/newinvoice`,
	modifyInvoice: `${apiRoot}/modifyinvoice`,
	deleteInvoice: `${apiRoot}/deleteinvoice`,
	getUsersInvoices: `${apiRoot}/invoices`,
	updateInvoice: `${apiRoot}/invoices`,
}
